import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

class Navbar {
    constructor() {
        this.navHeader = document.querySelector('.navbar-custom');
        this.menuParent=document.querySelectorAll('.menu-item-has-children');
        const links = []
        this.menuParent.forEach((parent) => {
            const directChildrenLinks = parent.querySelectorAll('.navbar-custom__menu-link');
            const l = Array.from(directChildrenLinks).filter(link => link.parentNode === parent);
            links.push(...l)
        })
        this.navbarCustomLinks = links
        this.scrollBottom();
    }
    // 2. init
    init() {
        this.navbarCustomLinks.forEach(link => {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                this.classList.toggle("active");
                let content = this.nextElementSibling;
                if (content.style.maxHeight){
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                } 
            });
        });

        document.addEventListener("scroll", (event) => {
            let currentScrollPosition = window.scrollY;
            this.sticky(currentScrollPosition);
        });
    }

    sticky(currentScrollPosition) {
        if(this.navHeader){
            if(currentScrollPosition<=0){
                this.navHeader.classList.remove('small');
            }
            else if(currentScrollPosition >100){
                this.navHeader.classList.add('small');
            } else {
                this.navHeader.classList.remove('small');
            }
        }
    }
    
    getSectionId(){
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let value = params.section; 
        return value;
    }

    scrollBottom(){
        this.btnScrollToBottom=document.querySelector(".scroll-to-bottom");
        if(this.btnScrollToBottom){
            this.btnScrollToBottom.addEventListener('click', (event)=>{  
                event.preventDefault();
                gsap.to(window, {duration: 0.1, scrollTo: "#footer-copyright"});
            });
        }
    }
}
export default Navbar